var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',{attrs:{"type":"text","value":_vm.currentValue,"placeholder":_vm.fieldPlaceholder},on:{"input":function($event){return _vm.updateField(_vm.field, $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }